import Header from './Header';
import Footer from './Footer';
import "../scss/sobrenos.scss";


function SobreNos() {

    return (
        <div>
            <Header></Header>

            <div className='sobrenos'>
                <div className='sobrenos__header'></div>

                <div className='sobrenos__main'>
                    <h2 className='sobrenos__main__title'>Sobre Nós</h2>
                    <div className='sobrenos__main__text'>
                        <p>
                            A Cinética é uma publicação nascida em 2006 como um espaço de pensamento dedicado ao cinema e ao audiovisual. Desde a iniciativa disparadora dos ex-editores Cléber Eduardo, Eduardo Valente e Felipe Bragança naquele momento, a revista tem como pedra fundamental a ideia de um diálogo em movimento, que busca conversar com seu momento histórico, com a produção, com a realização, e com todos os elementos do ecossistema das imagens do mundo, e especialmente do Brasil.
                        </p>

                        <p>
                            Ao longo desses anos, a Cinética, em seu ímpeto por movimento constantes, variou de formato, de matiz editorial, de grupo de redação e edição, mas mesmo depois do intervalo dos últimos anos uma coisa se mantém: um compromisso de não ser a mesma, um desejo de responder diferentemente aos novos desafios que vêm com os novos cenários. O nascimento da Cinética está ligado a um momento histórico em que houve um claro ambiente de renovação do pensamento crítico sobre cinema vindo da internet, em contraposição à tendência do guia de consumo que se consolidava nos veículos tradicionais nos anos 1980 e 1990.
                        </p>

                        <p>
                            De certa forma, a chama que aquece o desejo que mantém este espaço acredita numa tradição da crítica brasileira, que tortuosamente se mantém ao longo da história do cinema brasileiro, em veículos que vêm e vão, que confia plenamente no exercício de uma atividade de reflexão que não se apoia nos fiadores conceituais da produção acadêmica corrente e nem na prescrição de consumo dos reféns das grandes distribuidoras e lançamentos massivos. A ideia que perpassa esses vinte anos se funda na crença do exercício de um pensamento independente, que experimenta, que arrisca, que deseja se aproximar do que ainda não existe e que aparece como sugestão do amanhã nas imagens de hoje e ontem. No mais, vocês podem conferir nos nossos arquivos toda a produção da revista, em suas diversas fases através do anos, pois acreditamos também na contribuição histórica desse espaço, no seu desejo de contribuir tanto com pesquisas quanto com qualquer pessoa interessada em um filme, que deseja ficar um pouco mais com ele. Este é o seu lugar. No mais, desejamos uma boa leitura e estadia agradável por aqui.
                        </p>

                        <p>
                            Leia <a href="https://nova.revistacinetica.com.br/categorias/editorial/1">aqui</a> os editoriais da Cinética.
                        </p>

                        <p>
                            Aqui você acessa os arquivos da revista entre
                            <a target="_blank" href="http://www.revistacinetica.com.br/arquivo.htm"> 2006-2013</a>,
                            <a target="_blank" href="http://revistacinetica.com.br/home/"> 2013-2016</a>,
                            <a target="_blank" href="http://revistacinetica.com.br/nova/"> 2016-2021</a>.
                        </p>
                    </div>
                </div>
            </div>

            <Footer></Footer>
        </div>
    )

}

export default SobreNos;
